//Constants
import * as ACTIONS from './actionTypes';

//Types
import { DealerInfo } from './types';
import { ActionGetDealerInfoAPISuccess } from './actions';
export interface DealerInfoState {
    info?: DealerInfo
}

const defaultState: DealerInfoState = {
    info: undefined
};


type DealerInfoAction = ActionGetDealerInfoAPISuccess;

function dealerinfoReducer(state: DealerInfoState = defaultState, action: DealerInfoAction): DealerInfoState {
    switch (action.type) {
        case ACTIONS.GET_DEALERINFO_API_SUCCESS:
            {
                const { dealerinfo } = action as ActionGetDealerInfoAPISuccess;
                return {
                    ...state,
                    info: dealerinfo
                }
            }
    }
    return {
        ...state
    }
}

export default dealerinfoReducer;